import { AxiosResponse } from 'axios';
import {
  AccountRecoveryRequest,
  AccountResetPasswordRequest
} from '@models/request';
import { api } from './base/api';
import { IAccountApi } from './base/accountApi';
import {
  AccountRecoveryResponse,
  UserResponse,
  UserTokenResponse
} from '../models/response';
import { Result } from '../models/common/resultResponse';

const baseRoute: string = 'Account';

export class AccountApi extends IAccountApi {
  accountRecoveryPasswordApi(
    request: AccountRecoveryRequest
  ): Promise<AxiosResponse<Result<AccountRecoveryResponse>>> {
    return api.post(`${baseRoute}/recovery`, request);
  }

  accountResetPasswordApi(
    request: AccountResetPasswordRequest
  ): Promise<AxiosResponse<Result<UserResponse>>> {
    return api.post(`${baseRoute}/reset`, request);
  }

  getUserLoggedApi(): Promise<AxiosResponse<Result<UserResponse>>> {
    return api.get(`${baseRoute}`);
  }

  getUserToken(
    userName: string
  ): Promise<AxiosResponse<Result<UserTokenResponse>>> {
    return api.get(`${baseRoute}/getusertoken`, { params: { userName } });
  }
}
